import { Alert, AlertTitle } from "@mui/material";
import React from "react";

const IndicationCreationCompte = () => {
  return (
    <>
      <Alert variant="outlined" severity="info">
        <AlertTitle>
          <b>Indication</b>
        </AlertTitle>
        Pour pouvoir postuler à une offre, vous devez d’abord disposer d’un
        compte.
        <br />
        <br />
        - Si vous n’avez pas encore de compte, veuillez en créer un.
        <br />
        - Lors de l’inscription, choisissez le type de compte correspondant à
        votre statut :
        <br />
        <li>
          <b>Consultant Individuel</b>
        </li>
        <li>
          <b>Association/Volontaire</b>
        </li>
        <li>
          <b>AGEX/Cabinet</b>
        </li>
      </Alert>
    </>
  );
};

export default IndicationCreationCompte;
